<template>
  <div class="c-filter">
    <ElForm label-width="0" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem>
        <ElInput v-model="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
          <i slot="append" @click="search" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem>
        <DateRangePicker v-model="dateRangeValue" @change="search" style="width: 220px" :clearable="false"></DateRangePicker>
      </ElFormItem>

      <ElFormItem label-width="80" label="管理人员">
        <el-select v-model="opId" placeholder="全部" filterable style="width: 160px" clearable>
          <el-option v-for="item in opIds" :key="item.opId" :label="item.name" :value="item.opId"> </el-option>
        </el-select>
      </ElFormItem>

      <ElButton type="primary" style="margin-left: 0" @click="search">查询</ElButton>
      <ElButton @click="$emit('on-open')">新建{{ open }}</ElButton>
      <ElButton @click="$emit('on-syncData')" :loading="syncLoading"> 同步账号数据 </ElButton>
      <ElButton @click="$emit('on-downData')" icon="el-icon-download">数据导出</ElButton>
    </ElForm>
  </div>
</template>
<script>
import moment from 'moment'
import { trim } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker/index.vue'
export default {
  name: 'afilter',
  components: { DateRangePicker },
  props: {
    placeholder: {
      type: String
    },
    syncLoading: {
      type: Boolean
    },
    open: {
      type: String
    },
    opIds: {
      type: Array
    }
  },
  methods: {
    search() {
      const [queryBeginTime, queryEndTime] = this.dateRangeValue || ['', '']
      let params = {
        queryBeginTime,
        queryEndTime,
        opId: this.opId
      }
      if (!params.queryBeginTime || !params.queryEndTime) {
        this.$Message.error({
          duration: 5,
          content: '请选择查询日期范围'
        })
        return
      }
      params = Object.assign(params, { keyWord: trim(this.keyword) === '' ? undefined : trim(this.keyword) })
      this.$emit('on-search', params)
    }
  },
  data() {
    return {
      keyword: '', // 关键词
      dateRangeValue: [],
      opId: undefined
    }
  },
  created() {
    const now = moment().format('YYYY-MM-DD')
    this.dateRangeValue = [now, now]
    this.search()
  }
}
</script>
